
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import Group from 'vux/src/components/group/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import value2name from 'vux/src/filters/value2name.js'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
components: {
Group,
XInput,
XHeader,
XButton,
Toast,
XAddress,
Checker,
CheckIcon,
CheckerItem
},
name: "myInfo",
data() {
return {
isReadonly: true,
issue: false,
invoiceType: 1,
invoiceTitle: 2,
invoice: {
company: "",
taxNumber: "",
bank: "",
bankAccount: "",
address: "",
tel: ""
},
type: "",
addressData: ChinaAddressV4Data,
account: "",
sequence: "",
email: "",
emobile: "",
ename: "",
etelephone: "",
idcard: "",
mobile: "",
name: "",
zipcode: "",
address1: [],
opid: "",
address2: "",
company: ''
};
},
methods: {
registerSubmit() {
if (this.company === '') {
alert('请填写工作单位')
return
}
if (this.issue) {
if (this.invoiceTitle === 2) {
if (this.invoice.company === "" || this.invoice.taxNumber === "") {
this.$vux.alert.show({
title: "",
content: "请补全发票信息后再提交"
});
return;
}
}
if (this.invoiceType === 2) {
if (
this.invoice.bank === "" ||
this.invoice.bankAccount === "" ||
this.invoice.address === "" ||
this.invoice.tel === ""
) {
this.$vux.alert.show({
title: "",
content: "请补全发票信息后再提交"
});
return;
}
}
}
if (this.address1.length !== 3 || !this.address2) {
this.$vux.alert.show({
title: "",
content: "请填写通讯地址"
});
return
}
let address = value2name(this.address1, ChinaAddressV4Data);
address = address.split(' ')
var invoiceAll = {};
if (this.issue) {
if (this.invoiceType == 1) {
this.invoice.bank = "";
this.invoice.bankAccount = "";
this.invoice.address = "";
this.invoice.tel = "";
this.type = "ValueAddedTaxInvoiceUnit";
if (this.invoiceTitle == 1) {
this.invoice.company = "";
this.invoice.taxNumber = "";
this.type = "ValueAddedTaxInvoiceOne";
}
} else {
this.type = "VatSpecialInvoice";
}
invoiceAll = {
"content": this.invoice,
"type": this.type
};
} else {
invoiceAll = {
"content": null,
"type": ''
};
}

var userInfo = {
sequence: this.sequence,
email: this.email,
emobile: this.emobile,
ename: this.ename,
etelephone: this.etelephone,
idcard: this.idcard,
mobile: this.mobile,
name: this.name,
zipcode: this.zipcode,
company: this.company,
province: address[0],
city: address[1],
district: address[2],
daddress: this.address2,
invoice: invoiceAll
};
var app = this;
var obj = {
headers: {
token: localStorage.getItem("token"),
opid: this.opid
}
};

this.$vux.confirm.show({
title: "",
content: "修改信息需要重新进行审核,确认修改？",
onConfirm() {
app.$http
.put("/api/v1/users/" + app.opid, userInfo, obj)
.then((response) => {
app.$router.push({'name': 'vip'})
app.$vux.toast.show({
text: "修改成功",
type: "success",
time: "1000"
});
})
.catch(function (error) {
if (error.response) {
if (error.response.data.error_message) {
app.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
});
}
} else if (error.request) {
console.log(error.request);
} else {
console.log("Error", error.message);
}
});
}
});
},
getUserInfo(opid) {
var app = this;
var obj = {
headers: {
token: localStorage.getItem("token"),
opid: opid
}
};
this.$http.get("/api/v1/users/" + opid, obj).then(function (response) {
if (response.data.detail) {
app.name = response.data.detail.name;
app.idcard = response.data.detail.idcard;
app.mobile = response.data.detail.mobile;
app.sequence = response.data.sequence;
app.email = response.data.detail.email;
app.emobile = response.data.detail.emobile;
app.ename = response.data.detail.ename;
app.etelephone = response.data.detail.etelephone;
app.company = response.data.detail.company;
app.address1 = [response.data.detail.province, response.data.detail.city, response.data.detail.district]
app.address2 = response.data.detail.daddress
app.zipcode = response.data.detail.zipcode;
if (response.data.detail.invoice && response.data.detail.invoice.content) {
app.invoice = response.data.detail.invoice.content
app.type = response.data.detail.invoice.type;
app.issue = true;
if (response.data.detail.invoice.type === "VatSpecialInvoice") {
app.invoiceType = 2;
} else {
app.invoiceType = 1;
if (response.data.detail.invoice.type === "ValueAddedTaxInvoiceUnit") {
app.invoiceTitle = 2;
} else {
app.invoiceTitle = 1;
}
}
} else {
app.issue = false;
}
if (response.data.detail.result !== 'APPROVED') {
app.isReadonly = false;
}
}
})
.catch(function (error) {
if (error.response) {
console.log(error.response.data);
} else if (error.request) {
console.log(error.request);
} else {
console.log("Error", error.message);
}
});
},

},
created() {

this.opid = localStorage.getItem("userid");
this.getUserInfo(this.opid);
}
};



// WEBPACK FOOTER //
// ./src/components/myInfo.vue